import { connect } from 'react-redux';
import { ILocalization } from '../../localization/definitions/types';
import { RootState } from '../../store';

interface ThesisOverviewProjectItemEmptyProps {
    onClick: React.MouseEventHandler<HTMLDivElement>;
    localization: ILocalization;
}

const ThesisOverviewProjectItemEmpty: React.FC<
    ThesisOverviewProjectItemEmptyProps
> = ({ onClick, localization }: ThesisOverviewProjectItemEmptyProps) => {
    const projectEmptyLocalization =
        localization.localizationStrings.susy.project.projectItemEmpty;
    return (
        <div className='col-12 col-sm-4 col-xxl-3 col-fill'>
            <div className='card thesisOverview-card-empty' onClick={onClick}>
                <div className='card-body justify-content-center align-items-center thesisOverview-card-empty-center'>
                    <div
                        className='btn btn-lg btn-rounded-circle btn-white lift'
                        onClick={onClick}
                    >
                        +
                    </div>

                    <div className='thesisOverview-card-empty-add-text'>
                        <div>{projectEmptyLocalization.addNew}</div>
                        <span>{projectEmptyLocalization.description}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    localization: state.localization,
});

export default connect(mapStateToProps)(ThesisOverviewProjectItemEmpty);
